import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft, Crown, BarChart3, Globe, Link2, QrCode, Palette, Infinity, Rocket, Shield, Clock, Download, ArrowRight } from 'lucide-react';
import { Button } from '../components/ui/button';
import { useAuth } from '../contexts/AuthContext';

const PremiumPage = () => {
  const { isAuthenticated } = useAuth();

  const upcomingFeatures = [
    {
      icon: Infinity,
      title: 'Sinirsiz Ozel Slug',
      description: 'Aylik 5 slug limitinden kurtulun. Istediginiz kadar ozel kisa link olusturun.',
      current: 'Ucretsiz: 5/ay'
    },
    {
      icon: BarChart3,
      title: 'Gelismis Analitik',
      description: 'Ulke/sehir bazinda cografi konum takibi, 1 yillik analitik gecmisi.',
      current: 'Ucretsiz: 30 gun'
    },
    {
      icon: Download,
      title: 'Veri Disa Aktarma',
      description: 'Tum tiklama verilerinizi CSV/Excel formatinda indirin ve raporlayin.',
      current: 'Mevcut degil'
    },
    {
      icon: Link2,
      title: 'Sinirsiz Link Olusturma',
      description: 'Aylik link olusturma limitlerinden kurtulun. Toplu olusturmada 500 link.',
      current: 'Ucretsiz: 50 link/toplu'
    },
    {
      icon: Globe,
      title: 'Birden Fazla Bio Sayfa',
      description: 'Farkli markalariniz icin birden fazla Link-in-Bio sayfasi olusturun.',
      current: 'Ucretsiz: 1 sayfa'
    },
    {
      icon: Palette,
      title: 'Ozel Tema ve Tasarim',
      description: 'Bio sayfalariniz icin ozel temalar, animasyonlar ve tasarim secenekleri.',
      current: 'Temel temalar'
    },
    {
      icon: QrCode,
      title: 'QR Kod Ozellestirme',
      description: 'QR kodlariniza logo ekleyin, renk ve tasarim ozellestirmeleri yapin.',
      current: 'Standart QR'
    },
    {
      icon: Shield,
      title: 'Gelismis Guvenlik',
      description: 'Link sifre korumasi, sure siniri ve erisim kontrolleri.',
      current: 'Temel koruma'
    },
    {
      icon: Rocket,
      title: 'API Erisimi',
      description: 'Programatik link olusturma ve yonetim icin RESTful API erisimi.',
      current: 'Mevcut degil'
    }
  ];

  return (
    <div className="min-h-screen bg-[#0A0A0B]">
      <nav className="fixed top-0 left-0 right-0 z-50 bg-[#0A0A0B]/80 backdrop-blur-xl border-b border-white/5">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex items-center justify-between h-16">
            <Link to="/" className="flex items-center gap-2">
              <img src="/logo.png" alt="BestURL" className="h-10 w-auto" />
            </Link>
            <div className="flex items-center gap-4">
              {isAuthenticated ? (
                <Link to="/panel">
                  <Button className="bg-cyan-600 hover:bg-cyan-500 text-white">Panele Git</Button>
                </Link>
              ) : (
                <>
                  <Link to="/giris">
                    <Button variant="ghost" className="text-slate-300 hover:text-white hover:bg-white/5">Giris Yap</Button>
                  </Link>
                  <Link to="/kayit">
                    <Button className="bg-cyan-600 hover:bg-cyan-500 text-white">Ucretsiz Basla</Button>
                  </Link>
                </>
              )}
            </div>
          </div>
        </div>
      </nav>

      <section className="pt-32 pb-16 px-4 sm:px-6 lg:px-8">
        <div className="max-w-4xl mx-auto text-center">
          <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-amber-500/10 border border-amber-500/20 mb-8">
            <Crown className="w-4 h-4 text-amber-400" />
            <span className="text-sm text-amber-400 font-medium">Premium - Yakinda</span>
          </div>

          <h1 className="text-4xl sm:text-5xl lg:text-6xl font-extrabold text-white leading-tight mb-6">
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-amber-400 to-orange-500">Premium</span> ile
            <br />Sinirlamalari Kaldirin
          </h1>

          <p className="text-lg text-slate-400 max-w-2xl mx-auto mb-4">
            Profesyonel link yonetimi icin ihtiyaciniz olan tum gelismis ozellikler tek bir pakette.
            Premium abonelik yakinda kullanima sunulacak.
          </p>

          <div className="inline-flex items-center gap-2 px-6 py-3 rounded-2xl bg-[#121214] border border-white/10 mb-12">
            <Clock className="w-5 h-5 text-cyan-400" />
            <span className="text-slate-300">Abonelik ucreti yayin tarihinde belirlenecektir</span>
          </div>
        </div>
      </section>

      <section className="pb-20 px-4 sm:px-6 lg:px-8">
        <div className="max-w-6xl mx-auto">
          <div className="text-center mb-12">
            <h2 className="text-2xl sm:text-3xl font-bold text-white mb-4">Gelecek Premium Ozellikler</h2>
            <p className="text-slate-400">Premium abonelikle birlikte sunulacak ozellikler</p>
          </div>

          <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
            {upcomingFeatures.map((feature, index) => (
              <div
                key={index}
                className="group p-6 bg-[#121214] rounded-2xl border border-white/5 hover:border-amber-500/30 transition-all duration-300 relative overflow-hidden"
              >
                <div className="absolute top-3 right-3">
                  <span className="text-[10px] px-2 py-1 rounded-full bg-amber-500/10 text-amber-400 font-medium">YAKINDA</span>
                </div>
                <div className="w-12 h-12 rounded-xl bg-amber-500/10 flex items-center justify-center mb-4 group-hover:bg-amber-500/20 transition-colors duration-300">
                  <feature.icon className="w-6 h-6 text-amber-400" />
                </div>
                <h3 className="text-lg font-semibold text-white mb-2">{feature.title}</h3>
                <p className="text-slate-400 text-sm leading-relaxed mb-3">{feature.description}</p>
                <div className="text-xs text-slate-500 bg-white/5 rounded-lg px-3 py-2">
                  Simdi: {feature.current}
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="pb-20 px-4 sm:px-6 lg:px-8">
        <div className="max-w-4xl mx-auto">
          <div className="bg-gradient-to-br from-amber-500/10 via-[#121214] to-[#121214] rounded-3xl p-8 sm:p-12 border border-amber-500/20 text-center relative overflow-hidden">
            <div className="absolute inset-0 bg-gradient-to-br from-amber-500/5 via-transparent to-transparent" />
            <div className="relative">
              <Crown className="w-12 h-12 text-amber-400 mx-auto mb-6" />
              <h2 className="text-3xl font-bold text-white mb-4">Haberdar Olun</h2>
              <p className="text-slate-400 mb-8 max-w-lg mx-auto">
                Premium abonelik yayinlandiginda ilk siz haberdar olun. 
                Simdi ucretsiz hesap olusturun ve mevcut ozelliklerin keyfini cikarin.
              </p>
              <div className="flex flex-col sm:flex-row gap-4 justify-center">
                <Link to="/kayit">
                  <Button size="lg" className="bg-gradient-to-r from-amber-500 to-orange-500 hover:from-amber-400 hover:to-orange-400 text-white font-semibold shadow-[0_0_20px_rgba(245,158,11,0.3)]">
                    Ucretsiz Hesap Olustur
                    <ArrowRight className="w-5 h-5 ml-2" />
                  </Button>
                </Link>
                <Link to="/">
                  <Button size="lg" variant="outline" className="border-white/10 text-slate-300 hover:bg-white/5">
                    Ana Sayfaya Don
                  </Button>
                </Link>
              </div>
            </div>
          </div>
        </div>
      </section>

      <footer className="py-12 px-4 sm:px-6 lg:px-8 border-t border-white/5">
        <div className="max-w-7xl mx-auto">
          <div className="flex flex-col md:flex-row items-center justify-between gap-4">
            <Link to="/" className="flex items-center gap-2">
              <img src="/logo.png" alt="BestURL" className="h-8 w-auto" />
            </Link>
            <p className="text-slate-500 text-sm">&copy; 2026 BestURL. Tum haklari saklidir.</p>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default PremiumPage;
